/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SilenceAlarmRequest
 */
export interface SilenceAlarmRequest {
  /**
   *
   * @type {string}
   * @memberof SilenceAlarmRequest
   */
  alarmId: string;
  /**
   *
   * @type {string}
   * @memberof SilenceAlarmRequest
   */
  userEmail: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof SilenceAlarmRequest
   */
  silencedUntil: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof SilenceAlarmRequest
   */
  reason?: string | null;
}

/**
 * Check if a given object implements the SilenceAlarmRequest interface.
 */
export function instanceOfSilenceAlarmRequest(
  value: object,
): value is SilenceAlarmRequest {
  if (!("alarmId" in value) || value["alarmId"] === undefined) return false;
  if (!("userEmail" in value) || value["userEmail"] === undefined) return false;
  if (!("silencedUntil" in value) || value["silencedUntil"] === undefined)
    return false;
  return true;
}

export function SilenceAlarmRequestFromJSON(json: any): SilenceAlarmRequest {
  return SilenceAlarmRequestFromJSONTyped(json, false);
}

export function SilenceAlarmRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SilenceAlarmRequest {
  if (json == null) {
    return json;
  }
  return {
    alarmId: json["alarmId"],
    userEmail: json["userEmail"],
    silencedUntil: json["silencedUntil"],
    reason: json["reason"] == null ? undefined : json["reason"],
  };
}

export function SilenceAlarmRequestToJSON(json: any): SilenceAlarmRequest {
  return SilenceAlarmRequestToJSONTyped(json, false);
}

export function SilenceAlarmRequestToJSONTyped(
  value?: SilenceAlarmRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    alarmId: value["alarmId"],
    userEmail: value["userEmail"],
    silencedUntil: value["silencedUntil"],
    reason: value["reason"],
  };
}
